'use client';

import { useEffect, useState } from 'react';
import { getIsAccountLoggedIn } from '@/utils/account';

/**
 * Returns true when the `myAccountType` cookie is present and equals "power".
 * Reads the cookie once on mount; stable for the lifetime of the component.
 */
export function useAccountLogin(): boolean {
  const [isPowerUser, setIsPowerUser] = useState(false);

  useEffect(() => {
    setIsPowerUser(getIsAccountLoggedIn());
  }, []);

  return isPowerUser;
}
